import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, pageSize } from "@/mixins/index";
import addCompetitionStudent from './component/addCompetitionStudent.vue';
import uploadImagetow from '@/components/uploadImagetow';
export default {
  name: "competitionStudent",
  components: {
    uploadImagetow: uploadImagetow,
    addCompetitionStudent: addCompetitionStudent
  },
  props: ['eventId'],
  mixins: [loadMoreList, pageSize],
  data: function data() {
    return {
      paramsData: {
        page: 1,
        page_size: 10
      },
      tableData: [],
      total: 0,
      delIds: []
    };
  },
  created: function created() {
    this.getList(1);
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    getList: function getList(page) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.paramsData.page = page;

                _this.$api.eventParticipantList(_objectSpread(_objectSpread({}, _this.paramsData), {}, {
                  event_id: _this.eventId
                })).then(function (res) {
                  if (res.code == 200) {
                    var data = res.data.data;
                    data.forEach(function (item) {
                      item.name = item.student.name;
                      item.phone = item.student.phone;
                      item.school = item.student.school;
                      item.id_card = item.student.id_card;
                    });
                    _this.tableData = data;
                    _this.total = res.data.total;
                  }
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    del: function del(dateList) {
      var _this2 = this;

      this.$confirm("此操作将删除该参赛学生, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var ids;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ids = dateList.map(function (item) {
                  return item.id;
                });

                _this2.$api.evenParticipantDelete({
                  ids: ids
                }).then(function (res) {
                  if (res.code == 200) {
                    _this2.$message.success("删除成功!");

                    _this2.getList(_this2.paramsData.page);
                  } else {
                    _this2.$message.error(res.msg);
                  }
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    },
    exportDataFn: function exportDataFn() {
      var _this3 = this;

      this.columns = [{
        label: '学生姓名',
        prop: 'name'
      }, {
        label: '学校',
        prop: 'school'
      }, {
        label: '电话',
        prop: 'phone'
      }, {
        label: '身份证',
        prop: 'id_card'
      }];
      this.$api.eventParticipantList(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        page_size: -1
      })).then(function (res) {
        if (res.code == 200) {
          _this3.expData = res.data;

          _this3.expData.forEach(function (item) {
            item.name = item.student.name;
            item.phone = item.student.phone;
            item.school = item.student.school;
            item.id_card = item.student.id_card;
          });

          _this3.$export.excel({
            columns: _this3.columns,
            data: _this3.expData,
            title: '参赛学生'
          });
        }
      });
    }
  }
};